module.exports = __webpack_public_path__ + "img/phone_second_guide.840cfc08.png";